import { ChangeDetectionStrategy, Component, computed, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { Tables } from '../../../../../shared/ui/shared-tables/tables/tables';
import { LoadState } from '../../../../../shared/ui/shared-tables/pagination/pagination.utils';
import { Loading } from '../../../../../utils/loading/loading';
import { ErrorData } from '../../../../../utils/error-data/error-data';
import { ActionInterface } from '../../../../../pages/admin-dashboard/pharmacies/pharmacies-list/pharmacies-list.model';
import { CategoryListItem } from '../../../../../pages/admin-dashboard/categories/category.model';
import { toCategoryTableRows } from './category-table-component.mapper';

const ACTIONS = {
  edit: { id: 1, titleEn: 'Edit Category', titleAr: 'تعديل التصنيف' },
  view: { id: 2, titleEn: 'View Category Details', titleAr: 'عرض تفاصيل التصنيف' },
  delete: { id: 3, titleEn: 'Delete Category', titleAr: 'حذف التصنيف' },
} satisfies Record<string, ActionInterface>;

@Component({
  selector: 'app-category-table-component',
  imports: [Tables, Loading, ErrorData],
  templateUrl: './category-table-component.html',
  styleUrl: './category-table-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryTableComponent {
  private locale = inject(LOCALE_ID);

  /** Categories of the current page only. */
  categories = input<CategoryListItem[]>([]);
  state = input<LoadState>('loading');
  currentPage = input<number>(1);
  itemsPerPage = input<number>(25);
  isFiltersApplied = input<boolean>(false);

  retry = output<void>();
  viewCategory = output<number>();
  editCategory = output<number>();
  deleteCategory = output<number>();

  isArabic = computed(() => this.locale.startsWith('ar'));

  rows = computed(() =>
    toCategoryTableRows(
      this.categories(),
      this.isArabic(),
      this.locale,
      (this.currentPage() - 1) * this.itemsPerPage() + 1,
    ),
  );

  headerItems = [
    { key: 'index', label: '#' },
    { key: 'name', label: $localize`:@@adminCategoriesTableHeaderName:Category Name` },
    { key: 'dateCreated', label: $localize`:@@adminCategoriesTableHeaderDateCreated:Date Created` },
    { key: 'lastUpdated', label: $localize`:@@adminCategoriesTableHeaderLastUpdated:Last Updated` },
    { key: 'actions', label: '', type: 'actions' },
  ];

  actions: ActionInterface[] = [ACTIONS.edit, ACTIONS.view, ACTIONS.delete];
  currentActions = signal<ActionInterface[]>(this.actions);

  handleAction(e: { event: Event; actionId: number; entity: { id: number } }) {
    e.event?.stopPropagation();
    switch (e.actionId) {
      case ACTIONS.edit.id:
        this.editCategory.emit(e.entity.id);
        break;
      case ACTIONS.view.id:
        this.viewCategory.emit(e.entity.id);
        break;
      case ACTIONS.delete.id:
        this.deleteCategory.emit(e.entity.id);
        break;
    }
  }
}
